import {createAsyncThunk} from "@reduxjs/toolkit";
import {iStateMessage} from "@/customTypes/GenericReduxTypes";
import {iGenericResponse} from "@/customTypes/CommonServiceTypes";
import {curryGetThunkName} from "@/projectUtils/ReduxUtil";
import {httpStatusCodes} from "@/customTypes/NetworkTypes";
import { storyProductService }  from "@/services/api/cresivoxServer";

//@ts-ignore
import {iStoryProductDTO, REDUCER_NAME} from "./Types";
const curriedGetThunkName = curryGetThunkName(REDUCER_NAME);

export const getStoryProductList = createAsyncThunk<
  iGenericResponse<any | null> | null,
  void, // 👈 No parameter needed
  {
    rejectValue: iStateMessage;
  }
>(
  curriedGetThunkName("storyProductList"),
  // @ts-expect-error
  async (_, { rejectWithValue }) => {
    try {
      // Assume your storyProductService already knows the vendorId
      const response = await storyProductService.getStoryProductList();

      if (response) {
        const { httpStatusCode, data, message } = response;

        switch (httpStatusCode) {
          case httpStatusCodes.SUCCESS_OK: {
            if (data && data.data) {
              return {
                httpStatusCode,
                data: data.data,
                message,
              };
            } else {
              return rejectWithValue({
                httpStatusCode,
                message,
              });
            }
          }
          default: {
            return rejectWithValue({
              httpStatusCode,
              message,
            });
          }
        }
      } else {
        return rejectWithValue({
          message: "No response received",
        });
      }
    } catch (error) {
      return rejectWithValue({
        message: "Something went wrong",
      });
    }
  }
);





export const getAllStoryProductList = createAsyncThunk<
  iGenericResponse<any> | null,
  void,
  { rejectValue: iStateMessage }
>(
  curriedGetThunkName("allStoryProductList"),
  // @ts-expect-error
  async (_, { rejectWithValue }) => {
    try {
      const response = await storyProductService.getAllStoryProductList();
      if (!response) return rejectWithValue({ message: "No response received" });

      const { httpStatusCode, data, message } = response;
      if (httpStatusCode === httpStatusCodes.SUCCESS_OK && data?.data) {
        return { httpStatusCode, data: data.data, message };
      }
      return rejectWithValue({ httpStatusCode, message });
    } catch (error) {
      console.error("🚀 ~ error:", error);
      return rejectWithValue({ message: "Something went wrong" });
    }
  }
);

// export const getAllWholesalerCommunity = createAsyncThunk<
//   iGenericResponse<any | null> | null,
// {wholesalerId:string},
//   {
// 	  rejectValue: iStateMessage;
//   }
// >(
//   curriedGetThunkName("getAllWholesalerCommunity"),
//   // @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
//   async ({wholesalerId}, {rejectWithValue}) => {
// 	  try {
// 		  const response = await storyProductService.getWholesalerStoryProduct(wholesalerId);
// 		  if (response) {
// 			  const {httpStatusCode, data, message} = response;

// 			  switch (httpStatusCode) {
// 				  case httpStatusCodes.SUCCESS_OK: {
// 					  if (data && data.data) {
// 						  return {
// 							  httpStatusCode,
// 							  data: data.data,
// 							  message,
// 						  };
// 					  } else {
// 						  return rejectWithValue({
// 							  httpStatusCode,
// 							  message,
// 						  });
// 					  }
// 				  }
// 				  default: {
// 					  return rejectWithValue({
// 						  httpStatusCode,
// 						  message,
// 					  });
// 				  }
// 			  }
// 		  } else {
// 			  return rejectWithValue({
// 				  message: "No response received",
// 			  });
// 		  }
// 	  } catch (error) {
// 		  console.log("🚀 ~ error:", error);
// 		  return rejectWithValue({
// 			  message: "Something went wrong",
// 		  });
// 	  }
//   },
// );

export const getStoryProductById = createAsyncThunk<
iGenericResponse<any | null> | null,
{storyProductId:string},
{
	rejectValue: iStateMessage;
}
>(
curriedGetThunkName("getStoryProductById"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async (arg, {rejectWithValue}) => {
	try {
		const response = await storyProductService.getStoryProductById(arg);
		if (response) {
			const {httpStatusCode, data, message} = response;
			switch (httpStatusCode) {
				case httpStatusCodes.SUCCESS_OK: {
					if (data && data.data) {
						return {
							   data:{
								story: data.data,
								message,
							   }
							}
						
					} else {
						return rejectWithValue({
							httpStatusCode,
							message,
						});
					}
				}
				default: {
					return rejectWithValue({
						httpStatusCode,
						message,
					});
				}
			}
		} else {
			return rejectWithValue({
				message: "No response received",
			});
		}
	} catch (error) {
		return rejectWithValue({
			message: "Something went wrong",
		});
	}
},
);

export const updateStoryProduct = createAsyncThunk<
iGenericResponse<any | null> | null,
{storyProductId:string, data: iStoryProductDTO },
{
	rejectValue: iStateMessage;
}
>(
curriedGetThunkName("updateStoryProduct"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async ({storyProductId,data}, {rejectWithValue}) => {
	try {
		const response = await storyProductService.updateStoryProduct(storyProductId,data);
		if (response) {
			const {httpStatusCode, data, message} = response;

			switch (httpStatusCode) {
				case httpStatusCodes.SUCCESS_OK: {
					if (data && data.data) {
						return {
							data: {
								data: data.data,
								message,
							}
						};
					} else {
						return rejectWithValue({
							httpStatusCode,
							message,
						});
					}
				}
				default: {
					return rejectWithValue({
						httpStatusCode,
						message,
					});
				}
			}
		} else {
			return rejectWithValue({
				message: "No response received",
			});
		}
	} catch (error) {
		return rejectWithValue({
			message: "Something went wrong",
		});
	}
},
);

export const updateStoryProductStatus = createAsyncThunk<
iGenericResponse<any | null> | null,
{storyProductId:string, status: boolean},
{
	rejectValue: iStateMessage;
}
>(
curriedGetThunkName("updateStoryProductStatus"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async ({storyProductId,status}, {rejectWithValue}) => {
	try {
		const response = await storyProductService.updateStoryProductStatus(storyProductId,status);
		if (response) {
			const {httpStatusCode, data, message} = response;

			switch (httpStatusCode) {
				case httpStatusCodes.SUCCESS_OK: {
					if (data && data.data) {
						return {
							data: {
								data: data.data,
								message,
							}
						};
					} else {
						return rejectWithValue({
							httpStatusCode,
							message,
						});
					}
				}
				default: {
					return rejectWithValue({
						httpStatusCode,
						message,
					});
				}
			}
		} else {
			return rejectWithValue({
				message: "No response received",
			});
		}
	} catch (error) {
		return rejectWithValue({
			message: "Something went wrong",
		});
	}
},
);

export const deleteStoryProduct = createAsyncThunk<
iGenericResponse<any | null> | null,
{storyProductId:string},
{
	rejectValue: iStateMessage;
}
>(
curriedGetThunkName("deleteStoryProduct"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async ({storyProductId}, {rejectWithValue}) => {
	try {
		const response = await storyProductService.deleteStoryProduct(storyProductId);
		if (response) {
			const {httpStatusCode, data, message} = response;

			switch (httpStatusCode) {
				case httpStatusCodes.SUCCESS_OK: {
					if (data && data.data) {
						return {
								data: data.data,
								message,
							
						};
					} else {
						return rejectWithValue({
							httpStatusCode,
							message,
						});
					}
				}
				default: {
					return rejectWithValue({
						httpStatusCode,
						message,
					});
				}
			}
		} else {
			return rejectWithValue({
				message: "No response received",
			});
		}
	} catch (error) {
		return rejectWithValue({
			message: "Something went wrong",
		});
	}
},
);


export const createStoryProduct = createAsyncThunk<
iGenericResponse<any | null> | null,
iStoryProductDTO,
{
	rejectValue: iStateMessage;
}
>(


	
curriedGetThunkName("createStoryProduct"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async (payload, {rejectWithValue}) => {
	try {
		const response = await storyProductService.createStoryProduct(payload);
		if (response) {
			const {httpStatusCode, data, message} = response;
			switch (httpStatusCode) {
				case httpStatusCodes.SUCCESS_CREATED: {
					if (data && data.data) {
						return {
							data: {
								orders: data.data,
								message,
							}
						};
					} else {
						return rejectWithValue({
							httpStatusCode,
							message,
						});
					}
				}
				default: {
					return rejectWithValue({
						httpStatusCode,
						message,
					});
				}
			}
		} else {
			return rejectWithValue({
				message: "No response received",
			});
		}
	} catch (error) {
		return rejectWithValue({
			message: "Something went wrong",
		});
	}
},
);



// export const getAllWholesalerStoryProductWithoughtId = createAsyncThunk<
//   iGenericResponse<any> | null, // ✅ Ensure return type matches expected payload
//   void, // ✅ No parameter is needed
//   {
//     rejectValue: iStateMessage;
//   }
// >(
//   curriedGetThunkName("getAllWholesalerStoryProductWithoughtId"),
//   // @ts-expect-error
//   async (_, { rejectWithValue }) => {
//     try {
//       const response = await storyProductService.getAllWholesalerStoryProductWithoutId();

//       if (!response) {
//         return rejectWithValue({ message: "No response received" });
//       }

//       const { httpStatusCode, data, message } = response;

//       if (httpStatusCode === httpStatusCodes.SUCCESS_OK && data?.data) {
//         return {
//           httpStatusCode,
//           data: data.data, // ✅ Ensure the structure matches iGenericResponse
//           message,
//         };
//       }

//       return rejectWithValue({ httpStatusCode, message });
//     } catch (error) {
//       console.error("🚀 ~ Error fetching wholesaler community:", error);
//       return rejectWithValue({ message: "Something went wrong" });
//     }
//   }
// );